import { render, staticRenderFns } from "./BorderComplex.vue?vue&type=template&id=daf07e08&"
import script from "./BorderComplex.vue?vue&type=script&lang=ts&"
export * from "./BorderComplex.vue?vue&type=script&lang=ts&"
import style0 from "./BorderComplex.vue?vue&type=style&index=0&id=daf07e08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports